export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11355.33235ce8.jpg";